import React from 'react';
import { NavMenu } from './NavMenu';

export function Layout({ children }) {
  return (
    <div className="app-shell d-flex">
      <NavMenu />
      <main className="app-content flex-grow-1">
        {children}
      </main>
    </div>
  );
}
